import newsList from '@/view/news/newsList'
import newsDetail from '@/view/news/newsDetail'

const columnRouter = [
  {
    path: '/news/list.html',
    name: 'news-list',
    component: newsList,
    meta: {
      title: '河姆渡方案馆',
      keepAlive: true,
      isBack: false
    }
  },
  {
    path: '/news/detail/:id.html',
    name: 'news-detail',
    component: newsDetail,
    meta: {
      title: '资讯详情'
    }
  }
]

export default columnRouter



// WEBPACK FOOTER //
// ./src/router/news/news.js